import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useRef } from 'react';
import { useActiveSelectedSubaccount } from '../../hooks/useSelectedSubaccount';

export const SubaccountTracker = () => {
  const activeSubaccount = useActiveSelectedSubaccount();
  const queryClient = useQueryClient();
  const previousSubaccountIdRef = useRef<string | undefined>(undefined);

  const clearSubaccountQueries = useCallback(() => {
    // Clear all query cache data that contains subaccountId in their queryKey
    queryClient.removeQueries({
      predicate: (query) =>
        query.queryKey.some(
          (key) => typeof key === 'object' && key !== null && 'subaccountId' in key
        ),
    });
  }, [queryClient]);

  useEffect(() => {
    const currentSubaccountId = activeSubaccount?.id;
    const isSwitchingSubaccount =
      currentSubaccountId !== undefined && currentSubaccountId !== previousSubaccountIdRef.current;

    if (
      previousSubaccountIdRef.current !== undefined &&
      (isSwitchingSubaccount || currentSubaccountId === undefined)
    ) {
      clearSubaccountQueries();
    }

    previousSubaccountIdRef.current = currentSubaccountId;
  }, [activeSubaccount, clearSubaccountQueries]);

  return null;
};
